import React, { Component } from 'react';

import { arrayOf, bool, element, number, string } from 'prop-types';

import './card.scss';

import { CardAPI } from '@philips-emr/tws-components-api';
import { AwesomeComponent, ComponentType, ContainerProvider } from '@philips-emr/tws-core';
import { eventListener, oneOfType } from '@philips-emr/tws-core/lib/component/prop-types';
import { classNames, getLostProps, isValidWidth, propagateProps, trigger } from '@philips-emr/tws-utils';

const acceptedTypes = [
  ComponentType.BEHAVIOR,
  ComponentType.DATA_DISPLAY,
  ComponentType.LAYOUT,
];

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: CardAPI })
class Card extends Component {
  static propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    className: string,
    width: number,
    onClick: eventListener,
    onDoubleClick: eventListener,
    onContextMenuClick: eventListener,
    uuid: string,
    transparent: bool,
  };

  static defaultProps = {
    transparent: true,
    width: 3,
  };

  getClassName() {
    const { className, width, transparent } = this.props;

    return classNames({
      'c-card': true,
      'c-card--transparent': transparent,
      [`u-grid-col-${width}`]: isValidWidth(width),
      [className]: Boolean(className),
    });
  }

  render() {
    const { children, uuid, onClick, onDoubleClick, onContextMenuClick } = this.props;

    const Container = ContainerProvider.provide(this);

    return (
      <Container
        acceptedTypes={acceptedTypes}
        className={this.getClassName()}
        onClick={trigger(onClick)}
        onDoubleClick={trigger(onDoubleClick)}
        onContextMenu={trigger(onContextMenuClick)}
        uuid={uuid}
      >
        {propagateProps(children, getLostProps(Card.propTypes, this.props))}
      </Container>
    );
  }
}

export default Card;
